<template>
  <div class="page_content winners_page">

    <div class="carousel_section">
      <div class="container">
        <div class="row justify-content-center top_title">
          <h1>Hall of Fame</h1>
        </div>
      </div>

      <!--  Last Six Months Winners Carousel   -->

      <div class="container swiper_winners">

        <swiper ref="mySwiper" class="swiper swiper_winners" :options="carouselOptions" navigation>

          <swiper-slide v-for="prize in tempPhysicalPrizeWinners" :key="tempPhysicalPrizeWinners.rewardId" class="swiper-slide">
            <div class="slide_contains only_white">
              <img :src="prize.imageUrlMain" alt="">
              <div class="prize_title">{{ prize.rewardName }}</div>
              <div class="prize_text">{{ prize.lastName.toUpperCase()}}. uit {{ firstLetterCapital(prize.city) }}</div>
            </div>
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
        </swiper>

      </div>

      <!-- End Last Six Months Winners Carousel   -->

      <!-- Start Last Months Winners Section-->

      <div class="container winners_accordion">
        <div class="row justify-content-center">
          <h1>Winnaars van {{ this.defaultEndDate }}</h1>
        </div>

        <div class="winn_accord_box">
          <div v-for="(reward,index) in tempLastMonthWinners" :key="index"  v-if="reward.customWinners.length >0">
            <div class="outer" :id="'#accordion_' + reward.rewardId" >
              <a class="d-flex  align-items-center" data-toggle="collapse" :data-parent="'#accordion_' + reward.rewardId" :href="'#collapse' + reward.rewardId" @click="closeList(reward.rewardId)">
                <img :src="reward.imageUrlMain" alt=""/>
                <p><span>{{reward.customWinners.length}}x</span> winnaar(s) - {{reward.rewardName}}</p>
                <i class="fa fa-chevron-down ml-auto" :id="'accordion2_' + reward.rewardId"></i>
              </a>
              <div :id="'collapse' + reward.rewardId" class="collapse in">
                <div class="winn_accord_inside"  v-for="(winners, index) in reward.customWinners">
                  <p>{{winners.lastName.toUpperCase()}}. uit {{firstLetterCapital(winners.city)}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- End Last Months Winners Section-->

  </div>

</template>

<script>
  import {Swiper, SwiperSlide} from "vue-awesome-swiper";
  import {mapActions, mapGetters} from "vuex";
  import gameFlow from "../common/mixin/gameFlow";

  export default {
    name: "Winners",
    mixins:[
      gameFlow
    ],
    data() {
      return {
        carouselOptions: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 30,
            },
            320: {
              slidesPerView: 1.4,
              spaceBetween: 20,
              centeredSlides: true,
              initialSlide: 1
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
          navigation: {
            nextEl: ".swiper-button-next.one",
            prevEl: ".swiper-button-prev"
          },
        },
        tempPhysicalPrizeWinners: '',
        tempLastMonthWinners: '',
      }
    },

    components: {
      Swiper,
      SwiperSlide
    },

    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      },
      defaultEndDate() {
        const months = ["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"];
        const d = new Date();
        let month = months[d.getMonth()-1];
        return month;
      },
      ...mapGetters([
        'getPhysicalPrizeWinnersResponse',
        'getLastMonthWinnersResponse'
      ]),
      console: () => console,
    },
    mounted() {
      window.scrollTo(0, 0)
// Method that when the page is loading will last 6 months physical prize winners
      this.getPhysicalPrizeWinners()
        .then(() => {
          this.tempPhysicalPrizeWinners = this.getPhysicalPrizeWinnersResponse.body.winners
        })
      this.getLastMonthWinners()
        .then(() => {
          this.tempLastMonthWinners = this.getLastMonthWinnersResponse.body.rewards
        })
      this.setInGameFlow("false", this.$route.params)
    },
    methods: {
      ...mapActions([
        'getPhysicalPrizeWinners',
        'getLastMonthWinners'
      ]),
      closeList(id){
        let elem = document.getElementById('accordion2_'+id);
        $(elem).toggleClass("fa-chevron-down fa-chevron-up");
      },
      firstLetterCapital(str){
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
    }
  }
</script>

<style scoped>

  .swiper-slide {

    margin-bottom: 50px;
    top:10px;
    left:5px;

  }

  .swiper_winners {

    padding-right: 13px;
  }

  /*.outer_hr {*/
  /*  border-top: 1px solid rgba(0, 0, 0, .2);*/
  /*  margin-left: -55px;*/
  /*  margin-right: -55px;*/
  /*  margin-top: 20px;*/
  /*  margin-bottom: -10px;*/
  /*}*/

  /*.winn_accord_box .outer {*/
  /*  padding-top: 55px;*/
  /*  padding-bottom: 20px;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/Winners.vue